import { SpaceGroup } from '@signal-os/lock-space-meili-docs-types';
import meiliSearchApiClient from 'src/api/clients/meilisearch';
import tenantApi from 'src/api/clients/tenant';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { MeiliSearchResponse } from 'src/types/responses/meilisearch';
import { calculatePaginationOffset } from 'src/utils/calculate-pagination-offset';
import { UnassignSpaceFromSpaceGroupPayload } from '../types/payload/unassign-space-from-space-group.payload';

export const fetchSpaceGroups = async (
  tenantToken: string,
  searchState: SearchState,
  page: number,
  perPage: number,
) => {
  const { data } = await meiliSearchApiClient.post<
    MeiliSearchResponse<SpaceGroup>
  >(`/indexes/SpaceGroup-${tenantToken}/search`, {
    ...searchState,
    limit: perPage,
    offset: calculatePaginationOffset(page, perPage),
  });

  return data;
};

export const createSpaceGroup = async (name: string): Promise<string> => {
  const { data } = await tenantApi.post<{ token: string }>('/space-groups', {
    name,
  });

  return data.token;
};

export const assignSpacesToSpaceGroup = async (
  spaceGroupToken: string,
  spacesTokens: string[],
): Promise<void> => {
  await tenantApi.post(`/space-groups/${spaceGroupToken}`, {
    spacesTokens,
  });
};

export const updateSpaceGroupName = async (
  token: string,
  name: string,
): Promise<void> => {
  await tenantApi.put<void>(`/space-groups/${token}`, {
    name,
  });
};

export const deleteSpaceGroup = async (token: string): Promise<void> => {
  await tenantApi.delete<void>(`/space-groups/${token}/remove`);
};

export const assignEmployeeGroupsToSpaceGroup = async (
  spaceGroupToken: string,
  employeeGroupTokens: string[],
): Promise<void> => {
  await tenantApi.post<void>(
    `/space-groups/${spaceGroupToken}/employee-groups`,
    {
      employeeGroupTokens,
    },
  );
};

export const unassignSpaceFromSpaceGroup = async (
  payload: UnassignSpaceFromSpaceGroupPayload,
): Promise<void> => {
  await tenantApi.post(
    `/space-groups/${payload.spaceGroupToken}/spaces/${payload.spaceToken}/unassign`,
    {
      bookingsDecisions: payload.bookingsDecisions,
      bookingsDecisionsReason: payload.bookingsDecisionsReason,
    },
  );
};
